import React from "react";
import styled from "styled-components";
import {useChatStoreReducer, useChatTrackedState} from "./store";
import {Icon} from "@dspworkplace/ui";
import ChannelRow from "./ChannelRow";
import {Text, ReturnButton} from "./styles";

const ChatSidebarContainer = styled.div`
    display: ${props => (props.display ? props.display : "grid")};
    width: 300px;
    height: calc(100vh - 64px);
    box-shadow: 0 3px 6px #00000029;
    position: fixed;
    bottom: ${props => (props.bottom ? props.bottom : "5px")};
    right: ${props => (props.right ? props.right : "5px")};
    background-color: white;
`;

const ChannelsScrollContainer = styled.div`
    display: flex;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 73px);
    justify-content: flex-start;
    flex-direction: column;
    width: 300px;

    &::-webkit-scrollbar {
        width: 0;
    }
`;

const RowChannelKind = styled.div`
    display: grid;
    width: 260px;
    height: 44px;
    grid-template-columns: auto auto;
    align-items: center;
    justify-content: space-between;
    margin-left: 20px;
    margin-right: 20px;
    padding: 8px 0 0 0;
    cursor: default;
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
`;

const RowOptions = styled.div`
    display: grid;
    align-items: center;
    justify-content: flex-end;
    grid-column-gap: 16px;
    grid-template-columns: repeat(3, auto);
    margin: 2px 16px;
`;

// @ts-ignore
const DuoChannels: React.FC = () => {
    const state = useChatTrackedState();
    const {duoConversations} = state;
    // useEffect(() => {
    //     console.log(`Render DuoChannels ${JSON.stringify(duoChannels.length)}`);
    // });
    return <>
        {Array.isArray(duoConversations) && duoConversations.map((item, index) => {
            if (index <= 300) {
                return <ChannelRow key={`${item.sid}-${JSON.stringify(item.friendlyName)}`}
                    // @ts-ignore
                                   conversation={item}
                    // @ts-ignore
                                   kind={item.attributes['kind']}/>;
            }
            return null;
        })}
    </>
}

const GroupChannels: React.FC = () => {
    const state = useChatTrackedState();
    const {groupConversations} = state;
    // useEffect(() => {
    //     console.log(`Render GroupChannels ${JSON.stringify(groupChannels.length)}`);
    // });
    return <>
        {Array.isArray(groupConversations) && groupConversations.map((item) => (
            <ChannelRow
                key={`${item.sid}-${JSON.stringify(item.friendlyName)}`}
                // @ts-ignore
                conversation={item}
                // @ts-ignore
                kind={item.attributes['kind']}
            />
        ))}
    </>
}
//@ts-ignore
const BotChannels: React.FC = () => {
    const state = useChatTrackedState();
    const {botConversations} = state;
    // useEffect(() => {
    //     console.log(`Render BotChannels ${JSON.stringify(botChannels.length)}`);
    // });
    return <>
        {Array.isArray(botConversations) && botConversations.map(item => (
            <ChannelRow
                key={`${item.sid}-${JSON.stringify(item.friendlyName)}`}
                // @ts-ignore
                conversation={item}
                // @ts-ignore
                kind={item.attributes['kind']}
            />
        ))}
    </>
}

const PinChannels: React.FC = () => {
    const state = useChatTrackedState();
    const {pinConversations} = state;
    // useEffect(() => {
    //     console.log(`Render PinChannels ${JSON.stringify(pinChannels.length)}`);
    // });
    if (Array.isArray(pinConversations) && pinConversations.length > 0) {
        return (<>
            <RowChannelKind>
                <Text color={"#516F90"} fontSize={"20px"} margin={"0"} lineHeight={"unset"} height={"30px"}>
                    Pin
                </Text>
            </RowChannelKind>
            {pinConversations.map(item => (
                <ChannelRow
                    key={`${item.sid}-${JSON.stringify(item.friendlyName)}`}
                    // @ts-ignore
                    conversation={item}
                    // @ts-ignore
                    kind={item.attributes['kind']}/>
            ))}
        </>)
    }
    return null;
}

const ChatSidebar: React.FC = () => {
    const {state, dispatch} = useChatStoreReducer()
    const {initialChannelsReady, showFilterForWords} = state;
    // useEffect(() => {
    //     console.log(`Render ChatSidebar ${JSON.stringify({initialChannelsReady, initClient, showFilterForWords})}`);
    // });
    if (!initialChannelsReady) {
        return null;
    }

    return (
        <>
            <ChatSidebarContainer>
                <ChannelsScrollContainer>
                    <RowOptions>
                        {/*<ReturnButton*/}
                        {/*    width={"30px"}*/}
                        {/*    height={"30px"}*/}
                        {/*    borderRadius={"50%"}*/}
                        {/*    margin={"0 0 0 8px"}*/}
                        {/*>*/}
                        {/*    <Icon.Card*/}
                        {/*        size={"24px"}/>*/}
                        {/*</ReturnButton>*/}
                        {showFilterForWords && <ReturnButton
                            width={"30px"}
                            height={"30px"}
                            borderRadius={"50%"}
                            margin={"0 0 0 8px"}
                            onClick={() => dispatch({type: "OPEN_LIST_BAD_WORDS_MODAL"})}
                        >
                            <Icon.Filter
                                size={"24px"}/>
                        </ReturnButton>}
                        <ReturnButton
                            width={"30px"}
                            height={"30px"}
                            borderRadius={"50%"}
                            margin={"0 0 0 8px"}
                            onClick={() => dispatch({type: "OPEN_ARCHIVE_GROUP_MODAL"})}
                        >
                            <Icon.Archive
                                size={"24px"}/>
                        </ReturnButton>
                    </RowOptions>
                    <BotChannels/>
                    <PinChannels/>
                    <RowChannelKind>
                        <Text color={"#516F90"} fontSize={"20px"} margin={"0"} lineHeight={"unset"} height={"30px"}>
                            Groups
                        </Text>
                        <Row>
                            <ReturnButton
                                width={"30px"}
                                height={"30px"}
                                borderRadius={"50%"}
                                onClick={() => dispatch({type: "OPEN_NEW_CHANNEL_MODAL"})}
                            >
                                <Icon.Plus size={"24px"}/>
                            </ReturnButton>
                        </Row>
                    </RowChannelKind>
                    <GroupChannels/>
                    <RowChannelKind>
                        <Text color={"#516F90"} fontSize={"20px"} margin={"0"} lineHeight={"unset"} height={"30px"}>
                            Direct Messages
                        </Text>
                        <Row>
                            <ReturnButton
                                width={"30px"}
                                height={"30px"}
                                borderRadius={"50%"}
                                onClick={() => dispatch({type: "OPEN_DIRECT_MESSAGE_MODAL"})}
                            >
                                <Icon.Plus size={"24px"}/>
                            </ReturnButton>
                        </Row>
                    </RowChannelKind>
                    <DuoChannels/>
                </ChannelsScrollContainer>
            </ChatSidebarContainer>
        </>
    );
}

export default ChatSidebar;

